// routes/uiRoutes.tsx
import { Route } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import Accordion from '../pages/UiElements/Accordion';
import Alerts from '../pages/UiElements/Alerts';
import Avatars from '../pages/UiElements/Avatars';
import Badge from '../pages/UiElements/Badge';
import Breadcrumbs from '../pages/UiElements/Breadcrumbs';
import Buttons from '../pages/UiElements/Buttons';
import ButtonsGroup from '../pages/UiElements/ButtonsGroup';
import Cards from '../pages/UiElements/Cards';
import Carousel from '../pages/UiElements/Carousel';
import Dropdowns from '../pages/UiElements/Dropdowns';
import Images from '../pages/UiElements/Images';
import List from '../pages/UiElements/List';
import Modals from '../pages/UiElements/Modals';
import Notifications from '../pages/UiElements/Notifications';
import Pagination from '../pages/UiElements/Pagination';
import Popovers from '../pages/UiElements/Popovers';
import Progress from '../pages/UiElements/Progress';
import Spinners from '../pages/UiElements/Spinners';
import Tabs from '../pages/UiElements/Tabs';
import Tooltips from '../pages/UiElements/Tooltips';
import Videos from '../pages/UiElements/Videos';
import ProtectedRouteV2 from './ProtectedRouteV2';

const uiRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    <Route path="/ui/accordion" element={<><PageTitle title="Accordion UI" /><Accordion /></>} />
    <Route path="/ui/alerts" element={<><PageTitle title="Alerts UI" /><Alerts /></>} />
    <Route path="/ui/avatars" element={<><PageTitle title="Avatars UI" /><Avatars /></>} />
    <Route path="/ui/badge" element={<><PageTitle title="Badge UI" /><Badge /></>} />
    <Route path="/ui/breadcrumbs" element={<><PageTitle title="Breadcrumbs UI" /><Breadcrumbs /></>} />
    <Route path="/ui/buttons" element={<><PageTitle title="Buttons UI" /><Buttons /></>} />
    <Route path="/ui/buttons-group" element={<><PageTitle title="Buttons Group UI" /><ButtonsGroup /></>} />
    <Route path="/ui/cards" element={<><PageTitle title="Cards UI" /><Cards /></>} />
    <Route path="/ui/carousel" element={<><PageTitle title="Carousel UI" /><Carousel /></>} />
    <Route path="/ui/dropdowns" element={<><PageTitle title="Dropdowns UI" /><Dropdowns /></>} />
    <Route path="/ui/images" element={<><PageTitle title="Images UI" /><Images /></>} />
    <Route path="/ui/list" element={<><PageTitle title="List UI" /><List /></>} />
    <Route path="/ui/modals" element={<><PageTitle title="Modals UI" /><Modals /></>} />
    <Route path="/ui/notifications" element={<><PageTitle title="Notifications UI" /><Notifications /></>} />
    <Route path="/ui/pagination" element={<><PageTitle title="Pagination UI" /><Pagination /></>} />
    <Route path="/ui/popovers" element={<><PageTitle title="Popovers UI" /><Popovers /></>} />
    <Route path="/ui/progress" element={<><PageTitle title="Progress UI" /><Progress /></>} />
    <Route path="/ui/spinners" element={<><PageTitle title="Spinners UI" /><Spinners /></>} />
    <Route path="/ui/tabs" element={<><PageTitle title="Tabs UI" /><Tabs /></>} />
    <Route path="/ui/tooltips" element={<><PageTitle title="Tooltips UI" /><Tooltips /></>} />
    <Route path="/ui/videos" element={<><PageTitle title="Videos UI" /><Videos /></>} />
  </Route>
);

export default uiRoutes;
